import * as runtime from '../runtime';
import type { SellerSlugResponse } from '../models';

export interface GetSellerBySlugRequest {
  sellerSlugId: string;
}

/**
 *
 */
export class SellersApi extends runtime.BaseAPI {
  async getSellerBySlugRaw(
    requestParameters: GetSellerBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SellerSlugResponse>> {
    if (
      requestParameters.sellerSlugId === null ||
      requestParameters.sellerSlugId === undefined
    ) {
      throw new runtime.RequiredError(
        'sellerSlugId',
        'Required parameter requestParameters.sellerSlugId was null or undefined when calling getSellerBySlug.',
      );
    }

    const queryParameters: Record<
      string,
      string | string[] | number | boolean
    > = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/sellers/slugs/{sellerSlugId}`.replace(
          `{${'sellerSlugId'}}`,
          encodeURIComponent(String(requestParameters.sellerSlugId)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Gets the seller details for the given seller slug
   */
  async getSellerBySlug(
    requestParameters: GetSellerBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SellerSlugResponse> {
    const response = await this.getSellerBySlugRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
